<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M12 6.5V4m0 2.5H9.5C7.843 6.5 7 5.5 7 4s1-2.5 2.5-2.5S12 2.5 12 4m0 2.5h2.5C16 6.5 17 5.5 17 4s-1-2.5-2.5-2.5S12 2.343 12 4M4.5 12v9.5h15V12M12 7v14"/>
  <path stroke="#000" d="M3.5 11.5v-5h17v5h-17z"/>
</svg>
